import { WS_METHODS } from "@cmmd-forge/contracts";

import type { RpcUnaryMethod } from "./rpcClientTypes";
import { type WsTransport } from "./wsTransport";

export interface WsRpcAttachments {
  readonly createUploadUrl: RpcUnaryMethod<typeof WS_METHODS.attachmentsCreateUploadUrl>;
  readonly delete: RpcUnaryMethod<typeof WS_METHODS.attachmentsDelete>;
}

export function createWsRpcAttachments(transport: WsTransport): WsRpcAttachments {
  return {
    createUploadUrl: (input) =>
      transport.request((client) => client[WS_METHODS.attachmentsCreateUploadUrl](input)),
    delete: (input) => transport.request((client) => client[WS_METHODS.attachmentsDelete](input)),
  };
}
